module.exports = __webpack_public_path__ + "images/3_o1ae06d218241a737411d593bf1b679d4.svg";